import { Button, Group, TextInput } from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { createThread } from "./threadApi";
import { useStore } from "../../store";
import ModelSelect from "../../_Common/ModelSelect";

export default function PlaygroundThreadConfig() {
  const setThreadListTimestamp = useStore(
    (state) => state.setThreadListTimestamp
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: { title: "", model: "" },
    validate: {
      title: hasLength({ min: 3 }, "Must be at least 3 characters"),
    },
  });

  const createThreadHandler = (data) => {
    createThread(data).then(() => {
      // TBD: reload threads!
      setThreadListTimestamp(new Date());
    });
  };

  return (
    <>
      <form onSubmit={form.onSubmit(createThreadHandler)}>
        <TextInput
          {...form.getInputProps("title")}
          key={form.key("title")}
          label="Title"
          placeholder="Enter a short thread title"
        />
        <ModelSelect {...form.getInputProps("model")} />
        {/* <Select
          mt="xs"
          searchable
          {...form.getInputProps("model")}
          label="Default model"
          placeholder="Select model"
          data={supportedModels}
        /> */}

        <Group justify="flex-end">
          <Button type="submit" mt="md">
            Create
          </Button>
        </Group>
      </form>
    </>
  );
}
